Barba.Dispatcher.on("transitionCompleted", function () {
    if (document.getElementById("supportbutton") || document.getElementById("homesupportbutton")) {
        const header = new Vue({
            el: '.supportbuttonwrapper',
            store,
            data: function () {
                return {
                }
            },
            computed: {
                downloadSupport: {
                    get: function () {
                        return this.$store.getters.downloadSupport
                    },
                    set: function (newValue) {
                        this.$store.dispatch('toggleSupport', newValue)
                    }
                }
            },
            mounted: function () {
                this.getSupport();
            },
            methods: {
                getSupport: function() {
                    function isMacintosh() {
                        return navigator.platform.indexOf('Mac') > -1
                    }

                    function isWindows() {
                        return navigator.platform.indexOf('Win') > -1
                    }

                    if (isMacintosh()) {
                        this.downloadSupport = true;
                        document.querySelectorAll('.remotesupport__button').forEach(function(button) {
                            button.addEventListener('click', function(e) {
                                e.preventDefault();
                                window.open('/downloads/support.zip');
                            });
                        });
                    }
                    else if (isWindows()) {
                        this.downloadSupport = true;
                        document.querySelectorAll('.remotesupport__button').forEach(function(button) {
                            button.addEventListener('click', function(e) {
                                e.preventDefault();
                                window.open('/downloads/support.exe');
                            });
                        });
                    }
                    else {
                        this.downloadSupport = false;

                        document.querySelectorAll('.remotesupport__button').forEach(function(button) {
                            button.addEventListener('click', function(e) {
                                e.preventDefault();
                                window.open('/contact');
                            });
                        });
                    }
                }
            },
            created: function () {
            },
            destroyed: function () {
            }
        });
    }
});